firebird.factory('videoLayoutCompactService', [
    '$rootScope',
    '$timeout',
    '$window',
    'logService',
    'attendeeListService',
    'videoGlobalService',
    'helperService',
    function ($rootScope, $timeout, $window, logService, attendeeListService, videoGlobalService, helperService) {
        let service = {
            initialize: initialize
        };

        let self, $scope;

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            if (helperService.getQueryParameter('compactModeInBrowser') === 'true') {
                $window.$('#videoroom').attr('compact-mode-in-browser', 'true');
                $window.$('#header').attr('compact-mode-in-browser', 'true');
            }

            self.onCompactModeReceived = onCompactModeReceived;
            self.isCompactMode = false;

            self.compactData = {
                talkerActive: null,
                resetTimer: null,
                // factor and offset determine the size reduction and offset from edge for picture-in-picture.
                // with and without config values are for with and without compact mode enabled.
                pipFactorWith: 3,
                pipFactorWithout: 5,
                pipOffsetWith: 0,
                pipOffsetWithout: 10,
                updateTalkerTimeout: 1000,
                savedAnimation: null
            };

            self.compactAddAvatarIfNeeded = compactAddAvatarIfNeeded;
            self.compactRemoveAvatarIfNeeded = compactRemoveAvatarIfNeeded;

            self.compactIsAttendeePresent = compactIsAttendeePresent;
            self.compactOnAttendeeListChange = compactOnAttendeeListChange;

            self.compactAssignTalkerActive = compactAssignTalkerActive;
            self.compactUpdateTalkerLayout = compactUpdateTalkerLayout;
            self.compactAssignTalkerOnUpdateLayout = compactAssignTalkerOnUpdateLayout;

            self.compactAddExitOnClick = compactAddExitOnClick;
            self.compactAddVideoExitOnClick = compactAddVideoExitOnClick;
            self.compactExit = compactExit;

            $scope.$on('enable-compact-mode', self.onCompactModeReceived);
        }

        function onCompactModeReceived(e, data) {
            self.isCompactMode = data;
            self.layoutFactorPIP = self.isCompactMode
                ? self.compactData.pipFactorWith
                : self.compactData.pipFactorWithout;
            self.layoutOffsetPIP = self.isCompactMode
                ? self.compactData.pipOffsetWith
                : self.compactData.pipOffsetWithout;

            if (!self.isCompactMode) {
                self.compactRemoveAvatarIfNeeded();
                self.resetLayoutMaxVideo(null);
                self.compactData.talkerActive = null;
                if (self.compactData.savedAnimation) {
                    self.layoutPageUpdateAnimation(self.compactData.savedAnimation);
                    self.compactData.savedAnimation = null;
                }
                self.startLayoutPageFlipTask();

                // Reassign spotlighted attendee from active talker when exiting compact mode
                if (self.compactData.resetTimer) {
                    $timeout.cancel(self.compactData.resetTimer);
                    self.compactData.resetTimer = null;
                }
                self.compactData.resetTimer = $timeout(function () {
                    self.compactData.resetTimer = null;
                    const activeTalker = $window.$('#videoroom-videos > div[talker-active="true"]').get(0);

                    if (self.layoutPageData.layout == 'spotlight' && self.hasScreenDisplay) {
                        const primaryScreenShare = $window.$('#videoroom-videos > div.screen.primary').get(0);
                        if (primaryScreenShare) {
                            self.toggleVideoFullsize(primaryScreenShare);
                        } else {
                            self.toggleVideoFullsize($window.$('#videoroom-videos > div.screen.secondary').get(0));
                        }
                    } else if (self.layoutPageData.layout == 'spotlight' && activeTalker) {
                        self.toggleVideoFullsize(activeTalker);
                    } else {
                        self.updateVideosLayout();
                    }

                    $window.$('#videoroom-videos > div[talker-active="true"]').removeAttr('talker-active');
                }, 500);
            } else {
                self.compactData.savedAnimation = self.layoutPageDisableAnimation();
                self.stopLayoutPageFlipTask();
                $rootScope.$broadcast('hide-modal', 'meetingSettings');
                self.compactAddVideoExitOnClick();
            }
        }

        // Add avatar container and append attendee avatars here to always appear in compact mode with 0 videos displayed
        function compactAddAvatarIfNeeded() {
            if (!self.isCompactMode) {
                logService.warn('videoroomCtrl - compactAddAvatarIfNeeded called incorrectly');
                return;
            }

            const attendeeList = attendeeListService.getAttendeeList() || [];

            attendeeList.forEach(function (attendee, index) {
                const videoDiv = $window.$(
                    '#videoroom-videos > div:not(.video-avatar-container)[user="' + attendee.attendantId + '"]'
                );
                const avatarDiv = $window.$(
                    '#videoroom-videos > div.video-avatar-container[user="' + attendee.attendantId + '"]'
                );
                if (videoDiv.length) {
                    avatarDiv.remove();
                } else if (!avatarDiv.length) {
                    $window.$('#videoroom-videos').append(self.getAttendeeAvatar(attendee.attendantId));
                }
            });
        }

        function compactRemoveAvatarIfNeeded() {
            // Remove all avatar elements
            $window.$('#videoroom-videos > div.video-avatar-container').remove();
        }

        function compactIsAttendeePresent(attendeeId) {
            return $window.$('#videoroom-videos > div[user="' + attendeeId + '"]').length > 0;
        }

        function compactOnAttendeeListChange(data) {
            if (!self.isCompactMode) {
                logService.warn('videoroomCtrl - compactOnAttendeeListChange called incorrectly');
                return;
            }

            const compactAttendeeList = attendeeListService.getAttendeeList() || [];
            let attendeeIdList = compactAttendeeList.map(attendee => attendee.attendantId);
            let attendeeDivs = $window.$('#videoroom-videos > div[user]:not(.screen)');

            attendeeDivs.each(function () {
                let attendeeId = $window.$(this).attr('user');
                if (!attendeeIdList.includes(parseInt(attendeeId))) {
                    $window.$('#videoroom-videos > div.video-avatar-container[user="' + attendeeId + '"]').remove();
                }
            });

            // Update layout when attendee join/leaves
            if (attendeeDivs.length !== attendeeIdList.length) {
                self.updateVideosLayout();
            }

            // Update avatar img with custom avatar img once attendee is connected, if exist
            if (data && !helperService.isDefaultAvatarUrl(data.imageURL)) {
                $window.$('#videoroom-videos > div.video-avatar-container[user="' + data.attendantId + '"]').remove();
                self.updateVideosLayout();
            }
        }

        function compactAssignTalkerActive(attendeeId) {
            if ($window.$('#videoroom-videos > div.remote[user="' + attendeeId + '"]').length) {
                self.onLayoutPageUpdateTalker('' + attendeeId);
            }

            self.compactData.talkerActive = attendeeId;
            const attendeeDiv = $window.$('#videoroom-videos > div[user="' + attendeeId + '"]');
            attendeeDiv.attr('talker-active', 'true');
            attendeeDiv.removeAttr('compact-hidden');
            $window
                .$('#videoroom-videos > div:not(.screen):not(.audioonly):not(.local):not([user="' + attendeeId + '"])')
                .attr('compact-hidden', 'true');
        }

        function compactAssignTalkerOnUpdateLayout() {
            if (!self.isCompactMode) {
                logService.warn('videoroomCtrl - compactAssignTalkerOnUpdateLayout called incorrectly');
                return;
            }

            let spotlightedAttendee = $window
                .$('#videoroom-videos > div[spotlight="true"]:not(.screen):not(.local)')
                .first();

            const attendeeList = attendeeListService.getAttendeeList() || [];
            let attendeeToAssign =
                attendeeList.find(attendee =>
                    self.isHost ? attendee.attendeeType !== 'host' : attendee.attendeeType === 'host'
                ) ||
                attendeeList.find(attendee => attendee.attendantId != self.attendantId) ||
                attendeeList[0];

            if (attendeeList.length > 1 && self.compactData.talkerActive == self.attendantId) {
                // Local is active talker if they are the only attendee until there is more than 1 attendee
                self.compactData.talkerActive = null;
            }

            if (self.hasScreenDisplay) {
                // hide all video/avatar elements when screenshare is active
                $window.$('#videoroom-videos > div:not(.screen):not(.local)').attr('compact-hidden', 'true');
            } else if (spotlightedAttendee.length > 0 && !self.compactData.talkerActive) {
                // assign spotlighted attendee as active talker when entering compact mode
                self.compactAssignTalkerActive(spotlightedAttendee.attr('user'));
                spotlightedAttendee.removeAttr('spotlight');
            } else if (compactIsAttendeePresent(self.compactData.talkerActive)) {
                compactAssignTalkerActive(self.compactData.talkerActive);
            } else if (!compactIsAttendeePresent(self.compactData.talkerActive) && attendeeToAssign) {
                self.compactAssignTalkerActive(attendeeToAssign.attendantId);
            } else {
                // Show local avatar if only 1 attendee in the room
                $window.$('#videoroom-videos > div.video-avatar-container').removeAttr('compact-hidden');
            }
        }

        function compactUpdateTalkerLayout(isTalking, attendantId) {
            if (!self.isCompactMode) {
                logService.warn('videoroomCtrl - compactUpdateTalkerLayout called incorrectly');
                return;
            }

            let foundCompact = null;

            if (isTalking && self.compactData.talkerActive != attendantId && attendantId != self.attendantId) {
                foundCompact = attendantId;

                if (self.compactTalkerTimer) {
                    $timeout.cancel(self.compactTalkerTimer);
                    self.compactTalkerTimer = null;
                }

                self.compactTalkerTimer = $timeout(function () {
                    self.compactTalkerTimer = null;

                    let existingAttendee = self.findAttendee(self.compactData.talkerActive);
                    let activeAttendee = self.findAttendee(attendantId);

                    if (
                        foundCompact != self.compactData.talkerActive &&
                        (!existingAttendee ||
                            (!self.isAttendeeTalking(existingAttendee) && self.isAttendeeTalking(activeAttendee))) &&
                        self.isCompactMode
                    ) {
                        logService.log(
                            'videoroomCtrl - compactUpdateTalkerLayout talker changed ' +
                                self.compactData.talkerActive +
                                '=>' +
                                foundCompact +
                                ')'
                        );
                        self.compactData.talkerActive = foundCompact;

                        // TODO: how does it interact with .audioonly?
                        let foundDiv = $window.$('#videoroom-videos > div[user="' + foundCompact + '"]');
                        let otherDiv = $window.$(
                            '#videoroom-videos > div:not(.local):not(.screen):not([user="' + foundCompact + '"])'
                        );

                        if ($window.$('#videoroom-videos > div.remote[user="' + foundCompact + '"]').length) {
                            self.onLayoutPageUpdateTalker('' + foundCompact);
                        }

                        foundDiv.attr('talker-active', 'true');
                        foundDiv.removeAttr('compact-hidden');
                        otherDiv.removeAttr('talker-active');
                        otherDiv.attr('compact-hidden', 'true');
                    }
                }, self.compactData.updateTalkerTimeout);
            }
        }

        function compactAddExitOnClick() {
            let videoElements = $window.$('#videoroom-videos > div:not(.ui-draggable)');

            if (videoElements) {
                videoElements.each(function () {
                    this.onclick = function (event) {
                        if (self.isCompactMode) {
                            self.compactExit(event, this);
                        }
                    };
                });
            }
        }

        function compactAddVideoExitOnClick() {
            let videoElements = $window.$('#videoroom-videos > div.remote.screen.fileplay.primary.controls > video');

            if (videoElements) {
                videoElements.each(function () {
                    this.onclick = function (event) {
                        if (self.isCompactMode) {
                            self.compactExit(event, this);
                        }
                    };
                });
            }
        }

        function compactExit(event, element) {
            if (event.target != element) {
                event.stopPropagation();
                return;
            }
            $rootScope.$broadcast('enable-compact-mode', false);
        }
    }
]);
